// The privacy policy page (privacy.html, built beside the app). Arabic readers land on its Arabic text.
export const privacyHref = (lang) =>
  `${import.meta.env.BASE_URL}privacy.html${String(lang ?? "").startsWith("ar") ? "#ar" : ""}`;
